import React, { useEffect, useState, useContext } from "react";
import { useParams, useHistory } from "react-router";
import axios from "axios";
import { AuthContext } from "../helpers/AuthContext";
//import { PostContext } from "../helpers/PostContext";

function Profile() {
  let { id } = useParams();
  let history = useHistory();
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [listOfPosts, setListOfPosts] = useState([]);
  const { authState } = useContext(AuthContext);

  useEffect(() => {
    // const controller = new AbortController();

    // const fetchUsers = async () => {
    //   try {
    //   const resbasic = await axios.get("http://localhost:3000/auth/basicinfo/"+String(id),
    //   {signal : controller.signal});
    //   setUsername(resbasic.username);
    //   setEmail(resbasic.email);
    //   const resuser = await axios.get("http://localhost:3000/posts/byuserId/"+String(id),
    //   {signal : controller.signal});
    //   setListOfPosts(resuser);
    //   } catch(err) { 
    //     if (axios.isCancel(err)) return;
    //     console.log(err);
    //   }
    // };
    // fetchUsers();
    // return () => controller.abort();

  
    axios.get(`https://api.inloop.live/auth/basicinfo/${id}`).then((responses) => {
      setUsername(responses.data.username);
      setEmail(responses.data.email);
      console.log(username);
      console.log(email);
    });
    //setListOfPosts(PostContext);

    axios.get(`https://api.inloop.live/posts/byuserId/${id}`).then((response) => {
      setListOfPosts(response.data.listOfPosts);
      console.log(listOfPosts);
    });
  }, [id]);

  return (
    <div className="profilePageContainer">
      <h2>Profile</h2>
      <div className="basicInfo">
        {" "}
        <h1> Username: {username} </h1>
        <h2> Email: {email}</h2>
        {authState.username === username && (
          <button
            onClick={() => {
              history.push("/changepassword");
            }}
          >
            {" "}
            Change My Password
          </button>
        )}
      </div>
      <div className="listOfPosts">
        {listOfPosts.map((value, key) => {
          return (
            <div key={key} className="post">
              <div className="title"> {value.title} </div>
              <div
                className="body"
                onClick={() => {
                  history.push(`/post/${value.id}`);
                }}
              >
                {value.postText}
              </div>
              <div className="footer">
                <div className="username">{value.username}</div>
                <div className="buttons">
                  <label> {value.Likes.length}</label>
                </div>
              </div>
            </div>
          );
        })}
      </div>
      You are doing great!
    </div>
  );
}

export default Profile;
